module.exports = __webpack_public_path__ + "static/media/plan-wom-400gb-wom64.f0ad8a75.svg";